import { Header, LoadingSpinner, ServiceCard } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useServicesForUpload } from './use-services-for-upload';

const ServicesForUpload = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { services, pending } = useServicesForUpload();

  return (
    <div className="flex flex-col gap-4 py-4">
      <Header level="h2">{t('page.referralUploadJobs.services')}</Header>
      {pending ? (
        <LoadingSpinner />
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <ServiceCard
              description={service.referrerDescription ?? undefined}
              key={service.code}
              onClick={() => navigate(service.code)}
              title={service.description}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export { ServicesForUpload };
